<template>
  <div class="riseup-wl-progress-loader">
    <div class="content">
      <img
        src="../../../assets/riseup-wl-blue-logo.svg"
        class="riseup-wl-logo"
        alt="RiseupWL Logo"
      >
      <progress-stage-loader
        :current-stage="props.progressState.currentStage"
        :completed-stages="props.progressState.completedStages"
        :error="props.progressState.error"
        :status-message="props.progressState.statusMessage"
        :flow-config="riseupWlFlowConfig"
        force-text-color="#202125"
        force-font-family="SalaryFinance"
        :show-report-btn="true"
        @report-issue-click="handleReportIssueClick"
      />
    </div>
  </div>
</template>

<script setup>
import Segment from '../../../Segment';
import ProgressStageLoader from '../../Common/ProgressStageLoader.vue';

const props = defineProps({
  jobId: {
    type: String,
    required: true,
  },
  progressState: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(['report-issue-click']);

const handleReportIssueClick = () => {
  emit('report-issue-click');
};

const riseupWlFlowConfig = {
  title: 'Analysing your data',
  description: 'This might take up to a few minutes to complete.',
  subDescription: '',
  stageMessages: {
    scrape: 'Collecting your financial data...',
    versionUpdate: 'Validating and organizing your account information...',
    featurama: 'Analysing your spending patterns to identify opportunities...',
    otis: 'Generating personalised recommendations for your financial goals...',
  },
};

// Track when component is entered
Segment.trackUserGot('RiseupWLProgressLoaderEntered');
</script>

<style lang="scss" scoped>
.riseup-wl-progress-loader {
  display: flex;
  flex-direction: column;
  height: 100vh;
  background-color: #EEF2F9; // RiseupWL specific background
}

.content {
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.riseup-wl-logo {
  width: 50%;
  margin-top: 25px;
  max-width: 200px;
}
</style>
